//#region src/core/ui/time-slider/chapters/vars.ts
/**
* CSS geometry and progress local to each chapter.
*
* @internal
*/
const TimeSliderChapterCSSVars = {
	start: "--media-slider-chapter-start",
	end: "--media-slider-chapter-end",
	width: "--media-slider-chapter-width",
	fill: "--media-slider-chapter-fill",
	buffer: "--media-slider-chapter-buffer"
};
//#endregion
export { TimeSliderChapterCSSVars };

//# sourceMappingURL=vars.js.map